import { BaseWebUrl } from '@/utils/request/baseWebUrl'

const PROJECT_RESOURCE_MD5_PATTERN = /(?:^|\/)([0-9a-f]{32})(?:$|\?)/i

/** 从 md5 或 shareres 资源地址中提取资源 md5。 */
export function extractProjectResourceMd5(value: string): string {
  const normalized = String(value || '').trim()
  if (/^[0-9a-f]{32}$/i.test(normalized)) return normalized.toLowerCase()
  const match = PROJECT_RESOURCE_MD5_PATTERN.exec(normalized)
  return match?.[1]?.toLowerCase() || ''
}

/** 使用当前运行环境的工程资源 CDN 拼接 shareres 地址。 */
export function buildCurrentProjectResourceUrl(md5: string): string {
  const normalized = extractProjectResourceMd5(md5)
  return normalized ? `${new BaseWebUrl().baseProjectResourceCdn}${normalized.slice(0, 2)}/${normalized}` : ''
}

/** 将已有 shareres 地址归一到当前分支资源 CDN，非 md5 资源地址原样返回。 */
export function normalizeProjectResourceCdnUrl(value: string): string {
  const normalized = String(value || '').trim()
  const md5 = extractProjectResourceMd5(normalized)
  return md5 ? buildCurrentProjectResourceUrl(md5) : normalized
}
